export default __webpack_public_path__ + "static/media/proclamation4.9bdc9f53.jpg";